document.addEventListener("click", (event) => {

  const question = event.target.closest(".faq-accordion__question");
  if (!question) return;

  const item = question.closest(".faq-accordion__item");
  if (!item) return;

  const answer = item.querySelector(".faq-accordion__answer");
  const isOpen = item.classList.contains("is-open");

  if (isOpen) {
    answer.style.maxHeight = "0px";
    item.classList.remove("is-open");
  } else {
    answer.style.maxHeight = answer.scrollHeight + "px";
    item.classList.add("is-open");
  }

});